import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Button, ButtonStyle, ButtonDirective } from 'primeng/button';
import { ButtonType } from './m-button.component.types';
import { NgClass } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-button',
  templateUrl: './m-button.component.html',
  styleUrl: './m-button.component.scss',
  providers: [ButtonStyle],
  imports: [ButtonDirective, NgClass]
})
export class MButtonComponent extends Button {
  @Input() override type: keyof typeof ButtonType = ButtonType.primary;

  get primengSeverity(): string {
    switch (this.type) {
      case ButtonType.success:
        return 'success';
      case ButtonType.menu:
        return 'contrast';
      case ButtonType.secondary:
        return 'secondary';
      default:
        return 'primary';
    }
  }

  get isText(): boolean {
    return this.type === ButtonType.tertiary;
  }

  // PrimeNG 20 applies the root class on the host via `host: { '[class]': "cn(cx('root'), styleClass)" }`.
  // This wrapper extends Button but renders its OWN inner <button pButton>, so that metadata is
  // inherited onto <m-button> too — duplicating the button chrome on the wrapper host.
  // Neutralize on the wrapper host; the inner button is unaffected.
  override cx(): string {
    return '';
  }
}
